import { Box, Typography, Paper, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Monitors page for the Investing app
 * Displays monitoring dashboards for portfolio companies and investments
 */
const MonitorsPage = () => {
	const theme = useTheme();
	return (
		<Box sx={{ p: 4 }}>
			<Paper
				sx={{ p: 3, mb: 4, backgroundColor: theme.palette.background.paper }}
			>
				<Typography variant='h4' gutterBottom>
					Source Monitoring
				</Typography>
				<Typography variant='body1'>
					Track key information sources for deals you are working on
				</Typography>
			</Paper>

			<Grid container spacing={3}>
				{/* Placeholder for monitors list */}
				<Grid item xs={12}>
					<Paper
						sx={{
							p: 3,
							minHeight: 300,
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: theme.palette.action.hover,
						}}
					>
						<Typography variant='subtitle1' color='text.secondary'>
							Monitors Table (Coming Soon)
						</Typography>
						<Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
							Will include name, status, target
						</Typography>
					</Paper>
				</Grid>
			</Grid>
		</Box>
	);
};

export default MonitorsPage;
